import { AlertMessage } from 'components/notification/AlertMessage';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export default function useAlertMessage(props) {
    const {
        postDebitNote_errorMsg,
        deductCredit_errorMsg,
        deleteDebitNote_errorMsg,
    } = props;

    const [alertMsg, setAlertMsg] = useState([]);
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);
    const [isWarningMsgRequired, setIsWarningMsgRequired] = useState();
    
    // Error Messages
    function updateErrorMsg(msg) {
        if (func_validation.isStringTrimNotEmpty(msg)) {
            let alertMsg_new = func_validation.cloneArray(alertMsg);
            let index = func_validation.getArrayLength(alertMsg_new, 0);
    
            alertMsg_new.push(<p key={index}>{msg}</p>);
            setAlertMsg(alertMsg_new);
            setIsAlertMsgVisible(true);
        }
    } 
    useEffect(() => {
        updateErrorMsg(postDebitNote_errorMsg);
        setIsWarningMsgRequired(true);
    }, [postDebitNote_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deductCredit_errorMsg);
        setIsWarningMsgRequired(false);
    }, [deductCredit_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deleteDebitNote_errorMsg);
        setIsWarningMsgRequired(false);
    }, [deleteDebitNote_errorMsg]);

    let alertMsgDisplay = (
        <div className={"pb-3"}>
            <AlertMessage
                message={alertMsg}
                isVisible={isAlertMsgVisible}
                alertType={isWarningMsgRequired? "warning": undefined}
                toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
            />
        </div>
    );

    return {
        alertMsgDisplay,
        setAlertMsg
    };
}